import React from 'react';
import { useTheme } from '../context/ThemeContext';
import ChallengesComponent from '../components/Challenges';

function Challenges() {
  const { isDark } = useTheme();

  return (
    <div className="max-w-6xl mx-auto mt-16">
      <div className={`bg-white ${isDark ? 'dark:bg-hack-secondary/50' : 'bg-white'} rounded-lg shadow-xl overflow-hidden`}>
        <div className="px-8 py-12">
            <ChallengesComponent />
        </div>
      </div>
    </div>
  );
}

export default Challenges;
